// extracted by mini-css-extract-plugin
export default {"toolbar":"OverviewCompanies_toolbar__KuQ9g","form":"OverviewCompanies_form__jIAvt"};